module.exports = __webpack_public_path__ + "static/img/prize.6d6e5d6.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/prize.gif
// module id = 1gL+
// module chunks = 1